import { gql } from '@apollo/client';

export * from './appRequestAccept.mutation.generated';

export const APP_REQUEST_ACCEPT = gql`
  mutation appRequestAccept($appId: ID!, $appRequestId: ID!) {
    appRequestAccept(input: { appId: $appId, appRequestId: $appRequestId }) {
      errors
      success
      appRequest {
        id
      }
    }
  }
`;
